__turbopack_context__.v({
  "action": "StartSale-module-scss-module___KDSFq__action",
  "actions": "StartSale-module-scss-module___KDSFq__actions",
  "background": "StartSale-module-scss-module___KDSFq__background",
  "icon": "StartSale-module-scss-module___KDSFq__icon",
  "iconContainer": "StartSale-module-scss-module___KDSFq__iconContainer",
  "item": "StartSale-module-scss-module___KDSFq__item",
  "itemSubtitle": "StartSale-module-scss-module___KDSFq__itemSubtitle",
  "itemTitle": "StartSale-module-scss-module___KDSFq__itemTitle",
  "list": "StartSale-module-scss-module___KDSFq__list",
  "mainContainer": "StartSale-module-scss-module___KDSFq__mainContainer",
  "more": "StartSale-module-scss-module___KDSFq__more",
  "section": "StartSale-module-scss-module___KDSFq__section",
  "subtitle": "StartSale-module-scss-module___KDSFq__subtitle",
  "title": "StartSale-module-scss-module___KDSFq__title",
});
